import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import removeObjectPropertiesMatchingValue from '@grebban/utils/object/removePropertiesMatchingValue';
import useSiteMetaQuery from 'queries/useSiteMetaQuery';

/**
 * BreadcrumbsStructuredData for Grebcommerce
 * @version 1.0.1
 *
 * BreadcrumbsStructuredData Init in Breadcumbs
 * @param {object[]} items - The breadcrumbs data used in the Breadcrumbs-component
 */

const BreadcrumbsStructuredData = ({ items }) => {
    if (!items || items.length === 0) {
        return null;
    }

    const { path, siteURL } = useSiteMetaQuery();

    // Setup urls
    const localePath = path || '';
    const baseURL = `${siteURL}${localePath}`;

    // check if we have the breadcrumbs otherwise fallback to [].
    const structuredBreadcrumbs = items.map((item, i) => {
        const name = item.label;
        const link = item.to;
        return {
            '@type': 'ListItem',
            position: i + 1,
            name,
            item: link ? `${baseURL}${link}` : null,
        };
    });

    // List of breadcrumbs. we still want to return something to the structured data.
    const breadcrumbList = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: structuredBreadcrumbs,
    };

    // Remove null values from breadcrumbList
    removeObjectPropertiesMatchingValue(breadcrumbList, null);

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(breadcrumbList, null, 2)}</script>
        </Helmet>
    );
};

BreadcrumbsStructuredData.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            to: PropTypes.string,
        })
    ).isRequired,
};

export default BreadcrumbsStructuredData;
